module.exports = __webpack_public_path__ + "img/caret-left.7b8be4cc.svg";